import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {UserValidation} from '../shared/user-validation';
import {Location} from '@angular/common';
import {CardWebService} from '../shared/card-web.service';
import {GameDesignService} from '../design-recommender/shared/game-design.service';
import {MatDialog} from '@angular/material/dialog';
import {ImageDownloadDialogComponent} from '../image-download-dialog/image-download-dialog.component';
import {ObjectExtractingServiceService} from '../shared/object-extracting-service.service';
import {CustomObjectsService} from '../shared/custom-objects.service';
import { OnboardingService } from '../graph-editor/shared/onboarding-stepper.service';
import {MessageFactoryService} from '../shared/message-factory.service';

@Component({
  selector: 'em-extended-options',
  templateUrl: './extended-options.component.html',
  styleUrls: ['./extended-options.component.css']
})
export class ExtendedOptionsComponent implements OnInit {
  @Input() userValidation$: Observable<UserValidation>;
  @Input() shareOption: string;

  @ViewChild('resetConfirmDialog') resetConfirmDialog: TemplateRef<any>;

  private routePath = '';

  constructor(
    private router: Router,
    private location: Location,
    private cws: CardWebService,
    private cos: CustomObjectsService,
    private gs: GameDesignService,
    private dialog: MatDialog,
    private oes: ObjectExtractingServiceService,
    private obs: OnboardingService,
    private mfs: MessageFactoryService
  ) {
  }

  ngOnInit(): void {
    this.routePath = this.location.path();
    this.router.events.subscribe(() => {
      if (this.location.path() !== '') {
        this.routePath = this.location.path();
      } else {
        this.routePath = 'Home';
      }
    });
  }

  public isOnActiveRoute(routeName: string): boolean {
    if (routeName !== '') {
      return this.routePath.includes(routeName);
    }else{
      return this.routePath === '';
    }
  }

  public resetEditor() {
    this.cos.clearCustomObjects();
    this.cws.clearCustomCardWeb();
    this.gs.clearGameDesign();
    this.gs.clearGameDesignProblems();
    const messageObject = this.mfs.createMessageResetDesign();
    this.oes.handleAction(messageObject);
  }

  public openDownloadDialog() {
    this.dialog.open(ImageDownloadDialogComponent);
  }

  public cancelReset(): void {
    this.dialog.closeAll();
  }

   openResetConfirmDialog(): void {
    const dialogRef = this.dialog.open(this.resetConfirmDialog);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.resetEditor();
      }
    });
  }

  startTour() {
    if (this.isOnActiveRoute('home') || this.isOnActiveRoute('')) {
      this.obs.startDesignTour();
    }else if (this.isOnActiveRoute( 'editor')) {
      this.obs.startEditorTour();
    }
  }

  public downloadAsset(filename: string): boolean {
    window.open('../../assets/files/' + filename);
    return false;
  }

  canEdit() {
    return this.shareOption === null || this.shareOption !== 'view';
  }
}



